import {
  type GetPlaysArgs,
  useInfiniteScroll,
  useLazyGetPlaysQuery,
} from '@carboncopyco/data';
import type { Sort } from '@carboncopyco/types';
import constate from 'constate';
import { useMemo } from 'react';
import { useUrlState } from '../../utils';
import { usePlaybookPageProps } from './PlaybookPageContext';

type UrlState = {
  sort: Sort;
  creators: string;
  companies: string;
  query: string;
};

const initialUrlState: UrlState = {
  sort: 'last_updated',
  creators: '',
  companies: '',
  query: '',
};

export const usePresentations = ({ isArchive }: { isArchive?: boolean }) => {
  const { organizationId, playbookId, workspaceId } = usePlaybookPageProps();

  const [urlState] = useUrlState<UrlState>(initialUrlState);
  const fetchArgs = useMemo<GetPlaysArgs>(
    () => ({
      workspaces: [workspaceId],
      deletedEntities: isArchive,
      organizationId,
      assetId: playbookId,
      assetType: 'playbook',
      sort: urlState.sort,
      creators: urlState.creators.split(','),
      companies: urlState.companies.split(','),
      query: urlState.query,
    }),
    [organizationId, playbookId, urlState, isArchive, workspaceId]
  );
  const { items, addItem, ...rest } = useInfiniteScroll(useLazyGetPlaysQuery);

  return {
    urlState,
    fetchArgs,
    addItem,
    presentations: items,
    ...rest,
  };
};

export const [
  PresentationsProvider,
  usePresentationsContext,
  usePresentationsActions,
] = constate(
  usePresentations,
  (value) => value,
  (value) => ({ addItem: value.addItem })
);
